import { render, staticRenderFns } from "./Renewal.vue?vue&type=template&id=3a18bfd9&"
import script from "./Renewal.vue?vue&type=script&lang=ts&"
export * from "./Renewal.vue?vue&type=script&lang=ts&"
import style0 from "./Renewal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports